import { render, staticRenderFns } from "./RegistroClientesAdmin.vue?vue&type=template&id=2388e7ea&scoped=true&"
import script from "./RegistroClientesAdmin.vue?vue&type=script&lang=js&"
export * from "./RegistroClientesAdmin.vue?vue&type=script&lang=js&"
import style0 from "./RegistroClientesAdmin.vue?vue&type=style&index=0&id=2388e7ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2388e7ea",
  null
  
)

export default component.exports